export default __webpack_public_path__ + "static/media/Remitee Money Transfer HTTP API Reference.6b092de4.pdf";